<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
  <nav class="navbar fixed-top navbar-expand-lg navbar-light" id="navbar">
    <span *ngIf="isMenu && roleName" [style.display]="mobileQuery.matches ? 'block' : 'none'" class="app-icon"
      (click)="snav.toggle()"></span>
    <a class="navbar-brand logo-div"><img src="assets/images/logo.png" (click)="Startupweb()" class="img-fluid logo"
        alt="" /></a>
    <img [style.display]="mobileQuery.matches ? 'block' : 'none'" src="assets/icons/sort.png" class="img sort" alt=""
      data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
      aria-expanded="false" aria-label="Toggle navigation" />
    <div class="collapse navbar-collapse nav-menu-div" id="navbarSupportedContent">
      <!-- not Login -->
      <ul class="navbar-nav nav-alignment ml-auto mr-3">
        <li class="nav-item" routerLink="/home" routerLinkActive="active" *ngIf="
            roleValue !== 'Admin' &&
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link">Home</a>
        </li>

        <!-- <li class="nav-item" routerLink="/CSRS" routerLinkActive="active"
                    *ngIf="roleValue !=='Admin' && roleValue !=='Incubator' && roleValue !=='Corporate'">
                    <a class="nav-link">CSRSpot</a>
                </li> -->

        <li class="nav-item dropdown" routerLinkActive="active" *ngIf="
            roleValue !== 'Admin' &&
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            Corporate
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <li class="newlist text-dark" (click)="openinovationpage()">
              <a class="text-dark"><span>Open Innovation</span></a>
            </li>
            <li class="dropdown-submenu newlist">
              <a class="dropdown-toggle text-dark"><span>Initiatives</span></a>
              <ul class="dropdown-menu">
                <li class="newlist" class="newsubdropdown" *ngFor="let item of element" (click)="viewInitiative2(item)">
                  <a class="text-dark"><span>{{ item }}</span></a>
                </li>
                <li class="newlist" routerLink="/ncoporate">
                  <a class="text-dark"><span>All</span></a>
                </li>
              </ul>
            </li>
            <li class="newlist">
              <a class="text-dark" routerLink="/CSRS" *ngIf="
                  roleValue !== 'Admin' &&
                  roleValue !== 'Incubator' &&
                  roleValue !== 'Corporate'
                "><span>CSRSpot</span></a>
            </li>
            <!-- <li class="newlist"><a class="" routerLink="/Pre-Incubator"
                                *ngIf="roleValue !=='Admin' && roleValue !=='Incubator' && roleValue !=='Corporate'"><span>Pre Incubator</span></a>
                        </li> -->
          </ul>
        </li>
        <!-- <li class="nav-item"  routerLinkActive="active" *ngIf="roleValue !=='Admin' && roleValue !=='Incubator' && roleValue !=='Corporate'" >
                    <a class="nav-link" [matMenuTriggerFor]="corporatemenu">Corporate</a>
                    <mat-menu #corporatemenu="matMenu">
                        <button mat-menu-item (click)="openinovationpage()">
                           <span>Open Innovation</span>
                        </button>
                        <button mat-menu-item [matMenuTriggerFor]="acceletors">Initiatives</button>
                        <button mat-menu-item routerLink="/CSRS" *ngIf="roleValue !=='Admin' && roleValue !=='Incubator' && roleValue !=='Corporate'">CSRSpot</button>
                       </mat-menu>
                    <mat-menu #acceletors="matMenu" id="layout-manu" >
                        <button mat-menu-item *ngFor="let item of element" (click)="viewInitiative2(item)">
                            {{ item }}
                          </button>
                          <button mat-menu-item class="" routerLink="/ncoporate">All</button>
                       </mat-menu>
                </li> -->
        <li class="nav-item" routerLink="/uploadcsrsdoc" routerLinkActive="active" *ngIf="
            roleValue == 'Incubator' && roleValue !== 'Admin' && proReg == 'Yes'
          ">
          <!-- Upload csr Project -->
          <a class="nav-link">CSR Project</a>
        </li>
        <li class="nav-item" routerLink="/admin/pre-incubation" routerLinkActive="active"
          *ngIf="roleName == 'Preincubator'">
          <a class="nav-link">Pre Incubation</a>
        </li>
        <li class="nav-item" routerLink="/home" routerLinkActive="active" *ngIf="roleName == 'CoE'">
          <a class="nav-link">Home</a>
        </li>
        <li class="nav-item" routerLink="/admin/coe/dashboard" routerLinkActive="active" *ngIf="roleName == 'CoE'">
          <a class="nav-link">Dashboard</a>
        </li>
        <li *ngIf="roleName == 'CoE'" style="margin-top: 4px; border-right: 1px solid #fff; height: 23px">
          <span class="coe-change" *ngIf="proReg == 'Yes'" (click)="changepassword()">
            Change Password
          </span>
        </li>
        <li *ngIf="roleName == 'CoE'" style="margin-top: 4px">
          <span class="coe-change" (click)="logoutBtn()"> Logout </span>
        </li>
        <!-- <li class="nav-item" routerLink="/admin/pre-incubation" routerLinkActive="active"
                    *ngIf="roleName=='Incubator' && proReg=='Yes'">
                    <a class="nav-link">Pre Incubation</a>
                </li> -->
        <li class="nav-item" routerLink="/admin/incubatee" routerLinkActive="active"
          *ngIf="roleName == 'Incubator' && proReg == 'Yes'">
          <a class="nav-link">Incubatee Details</a>
        </li>
        <li class="nav-item" routerLink="/admin/event" routerLinkActive="active"
          *ngIf="roleName == 'Incubator' && proReg == 'Yes'">
          <a class="nav-link">Event</a>
        </li>
        <li class="nav-item" routerLink="/admin/news-letters" routerLinkActive="active"
          *ngIf="roleName == 'Incubator' && proReg == 'Yes'">
          <a class="nav-link">Newsletters</a>
        </li>

        <!-- <button *ngIf="roleName=='Incubator' && proReg=='Yes'" mat-menu-item
                (click)="incubateePage()">Incubatee Details</button>
                <button *ngIf="roleName=='Incubator'" mat-menu-item (click)="eventPage()">Event</button>
            <button mat-menu-item   *ngIf="roleName=='Incubator'" (click)="newsletterPage()">Newsletters</button> -->

        <!-- <li class="nav-item" routerLink="/resources" routerLinkActive="active" *ngIf="roleValue =='Corporate'" >
                    <a class="nav-link" >CSR Projects</a>
                </li> -->
        <li class="nav-item" routerLink="/csrsavailproject" routerLinkActive="active"
          *ngIf="roleValue == 'Corporate' && proReg == 'Yes'">
          <a class="nav-link">CSR Project</a>
        </li>
        <li class="nav-item" routerLink="/pre-incubators" routerLinkActive="active" *ngIf="
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Admin' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link">Pre-Incubation</a>
        </li>
        <li class="nav-item" routerLink="/coe" routerLinkActive="active" *ngIf="
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Admin' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link">CoE</a>
        </li>
        <li class="nav-item" routerLink="/incubators" routerLinkActive="active" *ngIf="
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Admin' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link">Incubators</a>
        </li>
        <li class="nav-item roleName" *ngIf="roleName == 'Admin'" [ngClass]="{ 'd-block': roleName == 'Admin' }"
          routerLink="/incubator-list" routerLinkActive="active">
          <a class="nav-link">Incubators</a>
        </li>
        <li class="nav-item roleName" *ngIf="roleName == 'Admin'" [ngClass]="{ 'd-block': roleName == 'Admin' }"
          routerLink="/pre-incubator-list" routerLinkActive="active">
          <a class="nav-link">Pre-Incubation</a>
        </li>
        <li class="nav-item roleName" *ngIf="roleName == 'Admin'" [ngClass]="{ 'd-block': roleName == 'Admin' }"
          routerLink="/coe-list" routerLinkActive="active">
          <a class="nav-link">CoE</a>
        </li>
        <li class="nav-item roleName" *ngIf="roleName == 'Admin'" [ngClass]="{ 'd-block': roleName == 'Admin' }"
          routerLink="/connectWithIncubator-list" routerLinkActive="active">
          <a class="nav-link">Connect With Incubator</a>
        </li>
        <!-- not Login -->
        <li class="nav-item" routerLink="/resources" routerLinkActive="active" *ngIf="
            roleValue !== 'Admin' &&
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link">Resources</a>
        </li>
        <li class="nav-item" routerLink="/initiatives" routerLinkActive="active" *ngIf="
            roleValue !== 'Admin' &&
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link" [matMenuTriggerFor]="menu2">Initiatives</a>
          <mat-menu #menu2="matMenu">
            <button mat-menu-item (click)="tnimmScroll()">
              <span>TNIMM 2.0</span>
            </button>
            <!-- <button mat-menu-item  [ngClass]="{ 'd-block': contactUs==false}" (click)="maturityScroll()">
                          <span >Maturity Level</span>
                        </button>
                        <button mat-menu-item (click)="assesmentScroll()">
                          <span>Assessment Domains</span>
                        </button> -->
            <button mat-menu-item (click)="scaleupScroll()">
              <span>Scaleup Incubators</span>
            </button>
            <button mat-menu-item (click)="hustleScroll()">
              <span>IM Hustle</span>
            </button>
            <button mat-menu-item (click)="helpdeskScroll()">
              <span>IM Helpdesk</span>
            </button>
            <button mat-menu-item (click)="podcastScroll()">
              <span>IM Podcast</span>
            </button>
            <!-- <button mat-menu-item (click)="expectScroll()">
                            <span>What to expect</span>
                          </button>
                          <button mat-menu-item (click)="tuneScroll()">
                            <span>How to tune it</span>
                          </button> -->
            <button mat-menu-item (click)="summitScroll()">
              <span>Incubators Summit</span>
            </button>
          </mat-menu>
        </li>
        <li class="nav-item" routerLink="/event" routerLinkActive="active" *ngIf="
            roleValue !== 'Admin' &&
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          " [ngClass]="{ 'd-none': roleName == 'Admin' }">
          <a class="nav-link">Event</a>
        </li>
        <li class="nav-item roleName" routerLink="/admin/event" routerLinkActive="active"
          [ngClass]="{ 'd-block': roleName == 'Admin' }">
          <a class="nav-link">Event</a>
        </li>
        <li class="nav-item roleName" routerLink="/admin/corinitiatives" routerLinkActive="active"
          [ngClass]="{ 'd-block': roleName == 'Admin' }">
          <a class="nav-link">Initiatives</a>
        </li>
        <li class="nav-item roleName" routerLink="/admin/csr" routerLinkActive="active"
          [ngClass]="{ 'd-block': roleName == 'Admin' }">
          <a class="nav-link">CSR Projects</a>
        </li>
        <li class="nav-item dropdown" routerLinkActive="active" *ngIf="roleName == 'Admin'">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            Media
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <li class="nav-item roleName" routerLink="/admin/blog/list" routerLinkActive="active"
              [ngClass]="{ 'd-block': roleName == 'Admin' }">
              <a class="nav-link">Blog</a>
            </li>
            <li class="nav-item roleName" routerLink="/admin/gallery" routerLinkActive="active"
              [ngClass]="{ 'd-block': roleName == 'Admin' }">
              <a class="nav-link">Gallery</a>
            </li>
            <li class="nav-item roleName" routerLink="/admin/news-letters" routerLinkActive="active"
              [ngClass]="{ 'd-block': roleName == 'Admin' }">
              <a class="nav-link">Newsletters</a>
            </li>
          </ul>
        </li>

        <!-- <button mat-menu-item *ngIf="roleName=='Admin'" (click)="blogPage()">Blog</button>
                <button mat-menu-item *ngIf="roleName=='Admin'" (click)="galleryPage()">Gallery</button>
               <button mat-menu-item *ngIf="roleName=='Admin'" (click)="newsletterPage()">Newsletters</button> -->

        <!-- <li class="nav-item" routerLink="/gallery" routerLinkActive="active">
                    <a class="nav-link">Gallery</a>
                </li> -->
        <!-- <li class="nav-item" routerLink="/admin/gallery/newsletters" routerLinkActive="active">
                    <a class="nav-link">Newsletters</a>
                </li> -->
        <!-- <li class="nav-item" routerLink="/blog" routerLinkActive="active">
                    <a class="nav-link">Blog</a>
                </li> -->

        <!-- not Login -->

        <li class="nav-item" [ngClass]="{ 'd-block': contactUs == false }" (click)="scrollTo()" *ngIf="
            roleValue !== 'Admin' &&
            roleValue !== 'Incubator' &&
            roleValue !== 'Corporate' &&
            roleValue !== 'Preincubator' &&
            roleValue !== 'CoE'
          ">
          <a class="nav-link">Contact</a>
        </li>
        <!-- *ngIf="roleName=='Incubator' && proReg=='Yes'" -->
        <!-- routerLink="/admin" -->
        <!-- routerLinkActive="active" -->
        <!-- (click)="incubatorLog()" routerLink="/admin" routerLinkActive="active" -->

        <!-- Temp Stop process -->
        <!-- <li class="nav-item roleName" (click)="incubatorLog()"
          [ngClass]="{ 'd-block': roleName == 'Incubator' && proReg == 'Yes' }">
          <a class="nav-link">TNIMM 2.0</a>
        </li> -->
        <li class="nav-item roleName" routerLink="/admin/tnimm2-page" routerLinkActive="active"
          [ngClass]="{ 'd-block': roleName == 'Incubator' && proReg == 'Yes' }">
          <a class="nav-link">TNIMM 2.0</a>
        </li>
        <!-- *ngIf="roleName=='Admin'" -->
      </ul>

      <form class="form-inlines p-relative" id="navLogout">
        <div class="d-flex">
          <div class="notify-icon" *ngIf="roleName == 'Admin'">
            <mat-icon (click)="incubatorApproval()" matBadge="{{ pendingCount }}"
              matBadgeColor="warn">notifications_active</mat-icon>
          </div>
          <button *ngIf="userName && roleValue != 'CoE'" class="border-none" [matMenuTriggerFor]="menu">
            <img [src]="image_url" class="img img-logo" alt="" />
          </button>
          <button (click)="loginBtn()" *ngIf="!userName" class="btn btn-register my-2 my-sm-0" type="submit">
            <a class="a-tag">Login</a>
          </button>
        </div>
        <mat-menu #menu="matMenu" xPosition="before">
          <button *ngIf="roleName == 'Incubator'" mat-menu-item (click)="profilePage()">
            Profile
          </button>
          <button *ngIf="roleName == 'Admin'" mat-menu-item (click)="incubatorApproval()">
            User Approval
          </button>
          <button *ngIf="roleName == 'Admin'" mat-menu-item [matMenuTriggerFor]="download">
            Download Excel
          </button>
          <button *ngIf="roleName == 'Admin'" mat-menu-item (click)="publishApi()">
            Publish Score
          </button>

          <button mat-menu-item *ngIf="roleName == 'Corporate'" (click)="corprateprofilePage()">
            Profile
          </button>
          <button *ngIf="proReg == 'Yes' && roleName != 'Preincubator'" mat-menu-item (click)="changepassword()">
            Change Password
          </button>
          <button class="newhoverbtn" *ngIf="proReg == 'Yes' && roleName == 'Preincubator'" mat-menu-item
            (click)="changepassword()">
            Change Password
          </button>
          <button *ngIf="roleName != 'Preincubator'" mat-menu-item (click)="logoutBtn()">
            Logout
          </button>
          <button class="newhoverbtn" *ngIf="roleName == 'Preincubator'" mat-menu-item (click)="logoutBtn()">
            Logout
          </button>
        </mat-menu>
        <mat-menu #pages="matMenu">
          <button mat-menu-item *ngIf="roleName == 'Incubator'" (click)="profilePage()">
            Profile
          </button>
        </mat-menu>
        <mat-menu #download="matMenu">
          <button mat-menu-item (click)="downloadExcel()">
            Incubatee Excel
          </button>
          <button mat-menu-item (click)="dowloadScore()">Scoring Excel</button>
        </mat-menu>
      </form>
    </div>
  </nav>
  <!-- [ngClass]="{ 'd-none': roleName=='Admin'}" -->
  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" fixedTopGap="65"
      [fixedInViewport]="mobileQuery.matches" [opened]="isShowing" [disableClose]="true">
      <mat-nav-list class="side" id="accordion">
        <div class="navigation">
          <ul *ngIf="roleName == 'Incubator'">
            <li class="list" [routerLink]="['admin', 'dashboard', userName]" routerLinkActive="active">
              <a (click)="checkToggle()">
                <span class="icon">
                  <ion-icon name="grid-outline"></ion-icon>
                </span>
                <span class="title">Incubation Management Areas</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'management-stratgey', userName]" routerLinkActive="active">
              <a (click)="checkToggle()">
                <span class="icon">
                  <ion-icon name="business-outline"></ion-icon>
                </span>
                <span class="title">Management Strategy</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'knowledge-expertise', userName]" routerLinkActive="active">
              <a>
                <span class="icon">
                  <ion-icon name="happy-outline"></ion-icon>
                </span>
                <span class="title">Knowledge & Expertise</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'financial', userName]" routerLinkActive="active">
              <a>
                <span class="icon">
                  <ion-icon name="cash-outline"></ion-icon>
                </span>
                <span class="title">Financial</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'hr', userName]" routerLinkActive="active">
              <a>
                <span class="icon">
                  <ion-icon name="megaphone-outline"></ion-icon>
                </span>
                <span class="title">HR</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'physical-infrastructure', userName]" routerLinkActive="active">
              <a>
                <span class="icon">
                  <ion-icon name="layers-outline"></ion-icon>
                </span>
                <span class="title">Physical Infrastructure</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'network-ecosystom', userName]" routerLinkActive="active">
              <a>
                <span class="icon">
                  <ion-icon name="globe-outline"></ion-icon>
                </span>
                <span class="title">Networking Ecosystem</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'social-impact', userName]" routerLinkActive="active">
              <a>
                <span class="icon">
                  <ion-icon name="earth-outline"></ion-icon>
                </span>
                <span class="title">Social Impact</span>
              </a>
            </li>
            <li class="list" [routerLink]="['admin', 'result-outcome', userName]" routerLinkActive="active">
              <a>
                <span class="icon">
                  <ion-icon name="newspaper-outline"></ion-icon>
                </span>
                <span class="title">Result & Outcome</span>
              </a>
            </li>
          </ul>
          <div *ngIf="
              currentUrl === '/admin/dashboard' ||
              currentUrl === '/admin/management-stratgey' ||
              currentUrl === '/admin/knowledge-expertise' ||
              currentUrl === '/admin/financial' ||
              currentUrl === '/admin/hr' ||
              currentUrl === '/admin/physical-infrastructure' ||
              currentUrl === '/admin/network-ecosystom' ||
              currentUrl === '/admin/social-impact' ||
              currentUrl === '/admin/result-outcome'
            ">
            <ul *ngIf="roleName == 'Admin'">
              <li class="list" routerLink="/admin/dashboard" routerLinkActive="active">
                <a (click)="checkToggle()">
                  <span class="icon">
                    <ion-icon name="grid-outline"></ion-icon>
                  </span>
                  <span class="title">Incubation Management Areas</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/management-stratgey" routerLinkActive="active">
                <a (click)="checkToggle()">
                  <span class="icon">
                    <ion-icon name="business-outline"></ion-icon>
                  </span>
                  <span class="title">Management Strategy</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/knowledge-expertise" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-flask"></i>
                  </span>
                  <span class="title">Knowledge & Expertise</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/financial" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-coins"></i>
                  </span>
                  <span class="title">Financial</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/hr" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <ion-icon name="megaphone-outline"></ion-icon>
                  </span>
                  <span class="title">HR</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/physical-infrastructure" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="far fa-building"></i>
                  </span>
                  <span class="title">Physical Infrastructure</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/network-ecosystom" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-network-wired"></i>
                  </span>
                  <span class="title">Networking Ecosystem</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/social-impact" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <ion-icon name="earth-outline"></ion-icon>
                  </span>
                  <span class="title">Social Impact</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/result-outcome" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <ion-icon name="newspaper-outline"></ion-icon>
                  </span>
                  <span class="title">Result & Outcome</span>
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="
              currentUrl === '/admin/pre-incubation/dashboard' ||
              currentUrl === '/admin/pre-incubation/host-institution' ||
              currentUrl === '/admin/pre-incubation/point-of-contact' ||
              currentUrl === '/admin/pre-incubation/track-record' ||
              currentUrl === '/admin/pre-incubation/infrastructure' ||
              currentUrl === '/admin/pre-incubation/intent-for-eoi'
            ">
            <ul *ngIf="roleName === 'Admin'">
              <li class="list" routerLink="/admin/pre-incubation/dashboard" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <ion-icon name="grid-outline"></ion-icon>
                  </span>
                  <span class="title">Application Dashboard</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/pre-incubation/host-institution" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-file-alt"></i>
                  </span>
                  <span class="title">Host Institution</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/pre-incubation/point-of-contact" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-flask"></i>
                  </span>
                  <span class="title">Point of Contact</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/pre-incubation/track-record" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-coins"></i>
                  </span>
                  <span class="title">Track Record</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/pre-incubation/infrastructure" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <ion-icon name="business-outline"></ion-icon>
                  </span>
                  <span class="title">Infrastructure</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/pre-incubation/intent-for-eoi" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-network-wired"></i>
                  </span>
                  <span class="title">Intent for EoI</span>
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="roleName == 'Preincubator'">
            <ul>
              <li class="list" [routerLink]="['admin', 'pre-incubation', 'dashboard']" routerLinkActive="active">
                <a (click)="checkToggle()">
                  <span class="icon">
                    <ion-icon name="grid-outline"></ion-icon>
                  </span>
                  <span class="title">Application Dashboard</span>
                </a>
              </li>
              <li class="list" [routerLink]="['admin', 'pre-incubation', 'host-institution']" routerLinkActive="active">
                <a (click)="checkToggle()">
                  <span class="icon">
                    <i class="fas fa-file-alt"></i>
                  </span>
                  <span class="title">Host Institution</span>
                </a>
              </li>
              <!-- <li
                class="list"
                [class.disabled]="applicationId == '0'"
                [routerLink]="
                  applicationId != '0' && [
                    'admin',
                    'pre-incubation',
                    'point-of-contact'
                  ]
                "
                routerLinkActive="active"
              >
                <a>
                  <span class="icon">
                    <i class="fas fa-user-alt"></i>
                  </span>
                  <span class="title">Point of Contact</span>
                </a>
              </li>
              <li
                class="list"
                [class.disabled]="applicationId == '0'"
                [routerLink]="
                  applicationId != '0' && [
                    'admin',
                    'pre-incubation',
                    'track-record'
                  ]
                "
                routerLinkActive="active"
              >
                <a>
                  <span class="icon">
                    <ion-icon name="cash-outline"></ion-icon>
                  </span>
                  <span class="title">Track Record</span>
                </a>
              </li>
              <li
                class="list"
                [class.disabled]="applicationId == '0'"
                [routerLink]="
                  applicationId != '0' && [
                    'admin',
                    'pre-incubation',
                    'infrastructure'
                  ]
                "
                routerLinkActive="active"
              >
                <a>
                  <span class="icon">
                    <ion-icon name="business-outline"></ion-icon>
                  </span>
                  <span class="title">Infrastructure</span>
                </a>
              </li>
              <li
                class="list"
                [class.disabled]="applicationId == '0'"
                [routerLink]="
                  applicationId != '0' && [
                    'admin',
                    'pre-incubation',
                    'intent-for-eoi'
                  ]
                "
                routerLinkActive="active"
              >
                <a>
                  <span class="icon">
                    <ion-icon name="layers-outline"></ion-icon>
                  </span>
                  <span class="title">Intent for EoI</span>
                </a>
              </li> -->
              <li *ngIf="applicationId != '0'" class="list"
                [routerLink]="['admin', 'pre-incubation', 'point-of-contact']" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-flask"></i>
                  </span>
                  <span class="title">Point of Contact</span>
                </a>
              </li>
              <li *ngIf="applicationId != '0'" class="list" [routerLink]="['admin', 'pre-incubation', 'track-record']"
                routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-coins"></i>
                  </span>
                  <span class="title">Track Record</span>
                </a>
              </li>
              <li *ngIf="applicationId != '0'" class="list" [routerLink]="['admin', 'pre-incubation', 'infrastructure']"
                routerLinkActive="active">
                <a>
                  <span class="icon">
                    <ion-icon name="business-outline"></ion-icon>
                  </span>
                  <span class="title">Infrastructure</span>
                </a>
              </li>
              <li *ngIf="applicationId != '0'" class="list" [routerLink]="['admin', 'pre-incubation', 'intent-for-eoi']"
                routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-network-wired"></i>
                  </span>
                  <span class="title">Intent for EoI</span>
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="
              currentUrl === '/admin/coe/dashboard' ||
              currentUrl === '/admin/coe/host-institution' ||
              currentUrl === '/admin/coe/point-of-contact' ||
              currentUrl === '/admin/coe/track-record' ||
              currentUrl === '/admin/coe/feasibility-sustainability' ||
              currentUrl === '/admin/coe/commitments-applicant' ||
              currentUrl === '/admin/coe/workplan' ||
              currentUrl === '/admin/coe/revenue-generation' ||
              currentUrl === '/admin/coe/declaration'
            ">
            <ul *ngIf="roleName === 'Admin'">
              <li class="list" routerLink="/admin/coe/dashboard" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <ion-icon name="grid-outline"></ion-icon>
                  </span>
                  <span class="title">Application Dashboard</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/host-institution" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-file-alt"></i>
                  </span>
                  <span class="title">Host Institution</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/point-of-contact" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-flask"></i>
                  </span>
                  <span class="title">Point of Contact</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/track-record" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-coins"></i>
                  </span>
                  <span class="title">Track Record</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/feasibility-sustainability" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-balance-scale"></i>
                  </span>
                  <span class="title">Feasibility Sustainability</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/commitments-applicant" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-handshake"></i>
                  </span>
                  <span class="title">Commitments From Applicant</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/workplan" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-coins"></i>
                  </span>
                  <span class="title">Workplan</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/revenue-generation" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-hand-holding-usd"></i>
                  </span>
                  <span class="title">Revenue Generation</span>
                </a>
              </li>
              <li class="list" routerLink="/admin/coe/declaration" routerLinkActive="active">
                <a>
                  <span class="icon">
                    <i class="fas fa-file-signature"></i>
                  </span>
                  <span class="title">Declaration </span>
                </a>
              </li>
            </ul>
          </div>

          <div *ngIf="roleName == 'CoE'">
            <ul>
              <li class="list" [routerLink]="['admin', 'coe', 'dashboard']" routerLinkActive="active">
                <a (click)="checkToggle()">
                  <span class="icon">
                    <ion-icon name="grid-outline"></ion-icon>
                  </span>
                  <span class="title">Application Dashboard</span>
                </a>
              </li>

              <li class="list" [routerLink]="['admin', 'coe', 'host-institution']" routerLinkActive="active">
                <a (click)="checkToggle()">
                  <span class="icon">
                    <i class="fas fa-file-alt"></i>
                  </span>
                  <span class="title">Host Institution</span>
                </a>
              </li>
              <!-- <li class="list" [class.disabled]="applicationId == '0'" [routerLink]="applicationId != '0' && ['admin', 'coe', 'point-of-contact']" routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-user-alt"></i>
                  </span>
                  <span class="title">Point of Contact</span>
                </a>
              </li> -->
              <li class="list" [routerLink]="
                  applicationId != '0' && ['admin', 'coe', 'point-of-contact']
                " routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-user-alt"></i>
                  </span>
                  <span class="title">Point of Contact</span>
                </a>
              </li>
              <li class="list" [routerLink]="
                  applicationId != '0' && ['admin', 'coe', 'track-record']
                " routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-coins"></i>
                  </span>
                  <span class="title">Track Record</span>
                </a>
              </li>
              <li class="list" [routerLink]="
                  applicationId != '0' && [
                    'admin',
                    'coe',
                    'feasibility-sustainability'
                  ]
                " routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-balance-scale"></i>
                  </span>
                  <span class="title">Feasibility Sustainability</span>
                </a>
              </li>
              <li class="list" [routerLink]="
                  applicationId != '0' && [
                    'admin',
                    'coe',
                    'commitments-applicant'
                  ]
                " routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-handshake"></i>
                  </span>
                  <span class="title">Commitments From Applicant</span>
                </a>
              </li>
              <li class="list" [routerLink]="
                  applicationId != '0' && ['admin', 'coe', 'workplan']
                " routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-coins"></i>
                  </span>
                  <span class="title">Workplan</span>
                </a>
              </li>
              <li class="list" [routerLink]="
                  applicationId != '0' && ['admin', 'coe', 'revenue-generation']
                " routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-hand-holding-usd"></i>
                  </span>
                  <span class="title">Revenue Generation</span>
                </a>
              </li>
              <li class="list" [routerLink]="
                  applicationId != '0' && ['admin', 'coe', 'declaration']
                " routerLinkActive="active" (click)="showPopup()">
                <a>
                  <span class="icon">
                    <i class="fas fa-file-signature"></i>
                  </span>
                  <span class="title">Declaration</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="main-section">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="d-flex">
          <img src="assets/images/alert-img.jpg" class="img-fluid alert-img" alt="" />
          <h4 class="alert-title">TNIMM filing is currently closed !</h4>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- modal -->
<div id="editModal" class="modal">
  <div class="modal-content text-center">
    <div class="text-center">
      <img class="image-sec" style="width: 100px" src="/assets/images/registration-1.png" alt="" />
    </div>
    <h3 style="font-size: 22px; font-weight: 500">
      Kindly complete the Host Institution section !
    </h3>

    <div class="text-center mt-2">
      <button class="incubatorBtn" (click)="closeModal()">OK</button>
    </div>
  </div>
</div>

<!-- line no 321 for TNIMM && 404 ul  -->